// extracted by mini-css-extract-plugin
export default {"interior":"interior__V9lB9","buttonwrapper":"buttonwrapper__F-zkJ","button":"button__upNu0","icon":"icon__zutxH"};